import React from 'react';
import { jwtDecode } from 'jwt-decode';
import DriveExplorer from '../../components/drive/DriveExplorer';

const AdhocDrive = () => {
  const token = localStorage.getItem('AuthToken');
  const identity = token ? jwtDecode(token) : {};
  const canManage = identity.role === 'admin' || identity.role === 'tecnico';
  return <main className="site-width drive-page"><DriveExplorer propietario={identity.usuario} canManage={canManage} /></main>;
};

export default AdhocDrive;
